module.exports = __webpack_public_path__ + "static/media/profile-rachel.15ad7e75.png";